import React, { Component } from 'react';
import { string, func, bool } from 'prop-types'

import styles from './TextBox.scss';

export default class TextBox extends Component {
    state = {
        text: '',
        valid: true
    }

    static propTypes = {
        id: string.isRequired,
        value: string,
        placeholder: string,
        onChange: func.isRequired,
        enabled: bool,
        icon: string,
        help: string
    }

    static defaultProps = {
        id: null,
        value: '',
        onChange: null,
        enabled: false,
        placeholder: '[placeholder]',
        icon: null,
        validator: null,
      }

    handleChange = (e) => {
        this.props.onChange({
            id: this.props.id,
            newValue: e.target.value
        })

        if (this.props.onChange) {
            var change = {
                oldValue: this.state.text,
                newValue: e.target.value,
                id: e.target.id
            };
            this.props.onChange(change);
        }
        this.setState({
            text: e.target.value
        });
    }

    validate = (text, textToCompareWith) => {
        let textToValidate = text != null ? text : this.state.text
        let isValid = false;
        let validator = this.props.validator;

        if (validator && textToValidate != null) {
            isValid = textToValidate.match(validator) != null;
        } else {
            isValid = textToValidate != '';
        }

        if (textToCompareWith != null && isValid) {
            isValid = (textToValidate == textToCompareWith || textToCompareWith == '');
        }
        this.setState({valid: isValid});
        return isValid;
    }

    render() {
        const {
            enabled,
            icon,
            id,
            placeholder,
            help
          } = this.props
        var classes = ['input'];
        if (!enabled) {
            classes.push('disabled-view');
        }
        if (!this.state.valid) {
            classes.push('error-view');
        }
        var iconMarkup = '';
        if (icon) {
            iconMarkup = (
                <label className="icon-right" htmlFor={id}>
                    <i className={"fa " + icon}></i>
                </label>
            );
        }

        var helpMarkup = '';
        if (help) {
            helpMarkup = (
                <span className={[styles.help, 'help'].join(' ')}>{help}</span>
            )
        }

        return (
            <div className={classes.join(' ')}>
                {iconMarkup}
                <input
                    onChange={this.handleChange}
                    value={this.state.text}
                    type="text"
                    disabled={!enabled}
                    id={id}
                    name={id}
                    placeholder={placeholder}
                 />
                 {helpMarkup}
            </div>
        )
      }
}


// WEBPACK FOOTER //
// ./app/components/TextBox.js